import $ from "jquery"

$(() => {
  // Show/hide former items
  $('body.resource_system input#system-show-former')
    .change(e =>
      $('table#itemlist').toggleClass('system-show-former', e.target.checked)
    ).change();

  // Show/hide former transactions
  $('body.resource_system input#system-show-former-ta')
    .change(e =>
      $('table#itemlist').toggleClass('system-show-former-ta', e.target.checked)
    ).change();
});
